const hour = new Date().getHours()
const cumprimentos = ['Olá', 'Oi']
if (hour > 5 && hour < 12) { cumprimentos.push('Bom dia') } else if (hour > 12 && hour < 18) { cumprimentos.push('Boa Tarde') } else { cumprimentos.push('Boa Noite') }

export default () => {
  return cumprimentos[Math.floor(Math.random() * cumprimentos.length)]
}
